import { useTranslation } from 'react-i18next';
import * as React from 'react';
import Drawer, { DrawerPropsTypes } from '../../Drawer/Drawer';
import { FooterButton } from '../types/enums';
import TabsComponent, { TabType, TabsPropsExtend } from '../../TabComponent/TabsComponent';
import { AdminTabType, TabDataExtend } from '../../TabComponent/types/propTypes';
import TextLink, { TextLinkStyle } from '../../TextLink/TextLink';
import { Theme } from '../../types/enums';
import { Button, ButtonSize, ButtonStyles, ButtonWidth } from '../../Form';
import styles from './CommonDrawer.module.scss';

interface CommonDrawerProps extends DrawerPropsTypes {
  primaryButtonTextChange?: string;
  onDeleteClick?: () => void;
  onEditClick?: () => void;
  onSignOutClick?: () => void;
  buttonType?: FooterButton;
}

const viewAllSection = (
  tabsProps: TabsPropsExtend,
  tabs: TabDataExtend[] | AdminTabType[],
  viewAllText: string,
  onViewAllClick?: () => void,
) => (
  <div className={styles['two-columns']}>
    <TabsComponent {...tabsProps} tabList={tabs} tabType={TabType.ADMIN} />
    {onViewAllClick && (
      <div className={styles['textlink']}>
        <TextLink
          data-testid="test-button-viewAll"
          text={viewAllText}
          textLinkStyle={TextLinkStyle.UNDERLINE}
          theme={Theme.PURPLE}
          onClick={onViewAllClick}
        />
      </div>
    )}
  </div>
);

export const CommonDrawer: React.FC<CommonDrawerProps> = ({
  primaryButtonTextChange: propButtonTextChange,
  header,
  children,
  buttonType = FooterButton.EDIT_DELETE_BTN,
  onClose,
  onDeleteClick,
  onEditClick,
  onSignOutClick,
}) => {
  const { t } = useTranslation();
  const labels = {
    deleteBtn: `${t('admin.summaryPane.deleteBtn')}`,
    editBtn: `${t('admin.summaryPane.editBtn')}`,
    signOutBtn: `${t('admin.summaryPane.signOutBtn')}`,
  };
  const defaultButtonText = labels.deleteBtn;
  const primaryButtonTextChange = propButtonTextChange || defaultButtonText;

  const editDeletebtn =
    !onDeleteClick && !onEditClick ? null : (
      <div className={styles['summary-pane-footer']}>
        {onDeleteClick && (
          <Button
            data-testid="delete-btn-testid"
            title={primaryButtonTextChange}
            buttonStyle={ButtonStyles.OUTLINE}
            onClick={onDeleteClick}
            size={ButtonSize.SMALL}
            buttonWidth={ButtonWidth.FULL_WIDTH}
          />
        )}
        {onEditClick && (
          <Button
            data-testid="edit-btn-testid"
            title={labels.editBtn}
            onClick={onEditClick}
            size={ButtonSize.SMALL}
            buttonWidth={ButtonWidth.FULL_WIDTH}
          />
        )}
      </div>
    );
  const signOutBtn = onSignOutClick && (
    <Button
      data-testid="sign-out-btn-testid"
      title={labels.signOutBtn}
      onClick={onSignOutClick}
      size={ButtonSize.SMALL}
      buttonWidth={ButtonWidth.FULL_WIDTH}
    />
  );
  return (
    <div data-testid="drawer-container">
      <Drawer
        header={header}
        footer={buttonType === FooterButton.EDIT_DELETE_BTN ? editDeletebtn : signOutBtn}
        drawerWidth="456px"
        closeIcon={true}
        closeOnBackdropClick={true}
        onClose={onClose}
      >
        {children}
      </Drawer>
    </div>
  );
};

export default CommonDrawer;
export { viewAllSection };
